export const ORGANIZATIONS_HOLIDAYS_FORM_NAME = 'organizationHolidays'
